'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'next',
    shape: _react2.default.createElement('path', { d: 'M384 512L128 320v128H0v128h128v128L384 512z' }),
    viewbox: '-39 275 470 470',
    label: 'Next'
};
//# sourceMappingURL=next.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/next.js
 ** module id = 691
 ** module chunks = 1
 **/